import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import type { CreanceViewMode } from "../creance.constants";
import { CreanceViewToggle } from "./CreanceViewToggle";

interface CreancesToolbarProps {
  search: string;
  onlyOverdue: boolean;
  viewMode: CreanceViewMode;
  rowsCount: number;
  onSearchChange: (value: string) => void;
  onOnlyOverdueChange: (value: boolean) => void;
  onViewModeChange: (mode: CreanceViewMode) => void;
}

export function CreancesToolbar({
  search,
  onlyOverdue,
  viewMode,
  rowsCount,
  onSearchChange,
  onOnlyOverdueChange,
  onViewModeChange,
}: CreancesToolbarProps) {
  return (
    <div className="mb-4 flex flex-col gap-3 border-y border-border py-3 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex flex-1 flex-col gap-2 sm:flex-row sm:items-center">
        <div className="relative max-w-xs flex-1">
          <Search
            size={13}
            className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-subtle"
          />
          <Input
            value={search}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Rechercher facture ou client..."
            className="pl-8"
          />
        </div>
        <label className="flex h-10 items-center gap-2 rounded-lg border border-border bg-card px-3 text-[12px] text-body">
          <input
            type="checkbox"
            checked={onlyOverdue}
            onChange={(event) => onOnlyOverdueChange(event.target.checked)}
            className="accent-brand-gold-dark"
          />
          En retard uniquement
        </label>
      </div>

      <div className="flex items-center justify-between gap-3">
        <p className="text-[11.5px] text-muted-foreground">
          {rowsCount} échéance{rowsCount !== 1 ? "s" : ""} avec solde dû
        </p>
        <CreanceViewToggle viewMode={viewMode} onViewModeChange={onViewModeChange} />
      </div>
    </div>
  );
}
